import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "No 6-hour Denver drive — we handle agency submission",
      "Ideal for Ellsworth AFB families on PCS orders",
      "Perfect for South Dakota Mines students studying abroad",
      "Great for Black Hills tourism professionals traveling internationally",
      "Rapid City Regional Airport (RAP) flyers",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no Denver drive required",
      "Faster than self-service at Rapid City post office",
      "Good for planned international trips from RAP",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Rapid City USPS is primary acceptance facility",
      "No document review — errors cause rejection and restart",
      "In-person clerk appointment required at Pennington County facilities",
      "Western SD mail routing adds extra transit days",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "No passport agency in South Dakota — closest is Denver, ~400 miles via US-85/I-25",
      "6+ hour drive to Denver Regional Agency",
      "NPIC appointment required — no walk-ins at Denver agency",
      "Life-or-death emergencies only with documentation",
      "Ellsworth AFB personnel may have additional military travel requirements",
      "Remote location makes same-day Denver trips impractical",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Rapid City"
      headingExtra="SD"
      introText="Rapid City travelers — Ellsworth Air Force Base families on PCS orders, South Dakota Mines students heading overseas for research, Black Hills hospitality professionals on international contracts, and Rapid City Regional Airport flyers — have several options for getting a passport fast. Here is how they compare, and why most South Dakotans choose a U.S. Department of State registered passport courier rather than making the 400-mile trek to Denver."
      options={options}
      emergencyDescription="South Dakota has zero passport agencies. The closest is in Denver — a 400-mile, 6+ hour drive one-way via US-85 and I-25. NPIC appointment is mandatory. Ellsworth AFB families with PCS orders may face additional military-specific documentation requirements."
      disclaimerText="*Processing speed depends on eligibility and documentation. South Dakota has no passport agency — the closest is Denver, CO (~400 miles). Not all applicants qualify for Regional Agency Processing."
    />
  );
}